import { useNavigation } from '@react-navigation/native';
import { useRecoilValue } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../routes/types';
import { productsCartStatusState } from '../../../store/batchTicket/atom';
import { productsCartCountSelector } from '../../../store/batchTicket/selectors';

export const useProductsSection = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const productsCartStatus = useRecoilValue(productsCartStatusState);
  const sectionTitle =
    productsCartStatus === 'complete' ? 'Produtos adicionados' : 'Adicione os produtos';

  const productsCartCount = useRecoilValue(productsCartCountSelector);

  const statusIsStart = productsCartStatus === 'start';
  const statusIsComplete = productsCartStatus === 'complete';
  const statusIsClosed = productsCartStatus === 'locked';

  const handleAddProducts = () => {};
  const handleEditProducts = () => {};
  const handlePressBasketButton = () => {
    navigate('BatchTicketCart', { key: 'addedProducts' });
  };

  return {
    statusIsComplete,
    statusIsStart,
    sectionTitle,
    statusIsClosed,
    itemCount: productsCartCount.assets,
    handleAddProducts,
    handleEditProducts,
    onPressBasketButton: handlePressBasketButton,
  };
};
